import { Middleware } from 'redux';
import ReducersIndex from 'reduxModules/ducks';
import { getRecalculate, getRemap, getAvailableArea } from 'reduxModules/selectors/containerSelectors';
import toolIndex from "toolConstants";
import { isEqual, isEmpty, omit, pick, keys } from 'lodash';
import { showError } from 'utilities/toastManager';
import { getIsLoadingDesign } from './loadingFlag';

interface Store {
  getState: () => any;
  dispatch: (action: any) => void;
}

const callerMiddleware: Middleware = ({ dispatch, getState }: Store) => (next) => (action) => {
  const currentStore = getState();
  next(action);
  let store = getState();

  // marker maybe I need to filter the action by only those actios that would trigger a recalculate 
  // fixme memoize these 
  
  const tool = store.container.currentTool;
    //skip if tool is calculated locally
  const localCalc = toolIndex[tool]?.constants.tool.localCalc ?? false;
  if (!localCalc) {
    
    // Get the parameters
    const containerParams = toolIndex[tool]?.constants?.containerParams ?? [];
    const areaParams = toolIndex[tool]?.constants?.areaParams ?? [];

    // destructure current state
    const { areas: currentAreas, ...currentContainer } = pick(currentStore.container, containerParams);
    const currentAreasKeys = keys(currentAreas);

    // destructure updated state 
    const { areas: updatedAreas, ...updatedContainer } = pick(store.container, containerParams);

    const containerChanged = !isEqual(currentContainer, updatedContainer);

    if (containerChanged) {
      dispatch(ReducersIndex.container.setRecalculate({ flag: true }))
    } else {
      currentAreasKeys.forEach((key, index) => {
        const areaExists = key in updatedAreas;
        const areaPre = pick(currentAreas[key], areaParams);
        const areaPost = areaExists ? pick(updatedAreas[key], areaParams) : {};
        const areaChanged = !isEqual(areaPre, areaPost);
        if (areaExists && areaChanged) {
          dispatch(ReducersIndex.container.setRecalculate({ area: key, flag: true }));
          if (!getIsLoadingDesign()) {
            dispatch(ReducersIndex.uiReducers.setNeedsResave(true));
          }
        }
      })
    };

    const viewFilter = !['floorplan', 'roof', 'areausage'].includes(store.ui.currentView);

    // marker 
    store = getState();
    const changed = getRecalculate(store) || getRemap(store);

    const ready = !store.ui.isModalOpen && viewFilter && changed;
    if (ready && store.ui.errorState) {
      // stop
      return
    }

    const debounceTime = (ready && action.type.includes('deleteSpeaker')) ? 2000 : 500

    // fixme: this is only for speakers in wd
    retriever(dispatch, getState, ready, debounceTime); //, { ...updatedContainer });
  };
};


// Marker retriever is pretty much fetch 
let saveTimer: NodeJS.Timeout;

const retriever = (dispatch: any, getState: any, ready: boolean, debounceTime = 500) => {
  const store = getState();
  const tool = store.container.currentTool;
  if (saveTimer) clearTimeout(saveTimer);

  saveTimer = setTimeout(() => {
    const getSpeakerLayout = async (payload: any, remap = false) => {
      try {
        const baseUrl = process.env.REACT_APP_ACOUSTICS_API_URL;

        if (!baseUrl) {
          dispatch(ReducersIndex.uiReducers.closeModal('calculating'));
          showError('Acoustics API URL is not configured. Please contact support.');
          return;
        }

        const endpoint = remap ? 'GetMapOfSpeakerLayout' : 'GetSpeakerLayout';
        const url = `${baseUrl}/${endpoint}`;

        const response = await fetch(url, {
        "method": "POST",
        "headers": {
          "content-type": "text/plain",
          "accept": "*/*"
        },
        "body": JSON.stringify(payload),
      });
      if (response.status === 200) {
        dispatch(ReducersIndex.uiReducers.closeModal('calculating'));
        const body = await response.text();
        const data = JSON.parse(body)
        if ('errornumber' in data) {
          dispatch(ReducersIndex.container.setRecalculate({ flag: false }));
          alert(data.errortext);
        } else {
          dispatch(ReducersIndex.container.setSpeakerLayout(JSON.parse(body)));
          dispatch(ReducersIndex.uiReducers.setAllowAddArea(!isEmpty(getAvailableArea(store.container))));
        }
      } else {
        console.error("API Error: ", response.statusText);
        dispatch(ReducersIndex.uiReducers.closeModal('calculating'));

        // Parse error response and show toast
        try {
          const errorBody = await response.text();
          const errorData = JSON.parse(errorBody);

          if (errorData.ErrorMessage) {
            showError(errorData.ErrorMessage);
          } else {
            showError(`API Error: ${response.statusText}`);
          }
        } catch (parseError) {
          console.error('Error parsing response:', parseError);
          // If parsing fails, show generic error
          showError(`API Error: ${response.statusText}`);
        }
      }
    } catch (error) {
      console.error("API Error:", error);
    }
    };

    // fixme
    if (ready && store.ui.tool === 'warehouseDesigner') {

      dispatch(ReducersIndex.uiReducers.openModal('calculating'));
      const remap = getRemap(store);
      const { container: containerFilterKeys, area: areaFilter } = toolIndex[tool].constants.callFilter;
      const areaFilterKeys = areaFilter(remap);
      const containerWithoutFiltered = omit(store.container, containerFilterKeys) as any;
      const { areas, ...container } = containerWithoutFiltered;

      const filtered = keys(areas).reduce((acc: any, key) => {
        acc[key] = omit(areas[key], areaFilterKeys);
        return acc
      }, {});
      // eslint-disable-next-line
      const payload = { ...container, ['areas']: filtered };
      getSpeakerLayout(payload, remap);
    };
  }, debounceTime);
};



export default callerMiddleware;